import {
  HomeIcon,
  TagIcon,
  WalletIcon,
  TableCellsIcon,
  DocumentTextIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/outline';
import Routes from '@/router/Routes.ts';
import { passToRouteSearchParams } from '@/utils/passToRouteSearchParams.ts';
import SearchParams from '@/_constants/SearchParams.ts';

export const navData = [
  {
    title: 'navbar.dashboard',
    path: Routes.DASHBOARD,
    icon: <HomeIcon />,
  },
  {
    title: 'navbar.inputs',
    path: Routes.INPUTS,
    icon: <DocumentTextIcon />,
  },
  {
    title: 'navbar.dataTable',
    path: Routes.DATA_TABLE,
    icon: <TableCellsIcon />,
  },
  {
    title: 'navbar.paymentSelect',
    path: passToRouteSearchParams(Routes.PAYMENT_SELECT, {
      [SearchParams.REDIRECT_URL]: encodeURIComponent(window.location.href),
    }),
    icon: <WalletIcon />,
  },
  {
    title: 'navbar.emailTemplate',
    path: Routes.EMAIL_TEMPLATE,
    icon: <EnvelopeIcon />,
  },
  {
    title: 'navbar.sandbox',
    path: Routes.SANDBOX,
    icon: <TagIcon />,
  },
];
